"use strict";
exports.__esModule = true;
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var mgmts;
        (function (mgmts) {
            var addressBook;
            (function (addressBook) {
                /**
                 * Verify input string as username.
                 *
                 * Username rule:
                 *     case insensitive,
                 *     length 1 to 20 (include),
                 *     only allow letters (a-z), numbers (0-9) and period (.)
                 *
                 * @param input {string} A string as username.
                 * @returns {boolean}
                 */
                addressBook.verifyUsername = function (input) {
                    if (typeof input !== 'string' || !input) {
                        // Type wrong or empty.
                        return false;
                    }
                    else if (input.length < 1 || input.length > 20) {
                        // Input too long.
                        return false;
                    }
                    else {
                        return /^[A-Za-z0-9\.]+$/.test(input);
                    }
                };
                /**
                 * Check if user exists in current user list.
                 *
                 * @param userlist {Array<{}>} List of users, should have username
                 *     property.
                 * @param input {{}} Input user.
                 * @returns {boolean} True if user exists.
                 */
                addressBook.usernameExists = function (userlist, input) {
                    if (!userlist || !userlist.length) {
                        // User list is empty.
                        return false;
                    }
                    else {
                        var rs = false;
                        for (var i = 0; i < userlist.length && !rs; i++) {
                            // Also check input type here.
                            if (userlist[i].username === input.username &&
                                userlist[i]._id !== input._id) {
                                rs = true;
                            }
                        }
                        return rs;
                    }
                };
                /**
                 * The email test we only use very very very very simple thing.
                 *
                 * @param input {string} String as email.
                 * @returns {boolean} True if it passes this dummy test.
                 */
                addressBook.verifyEmail = function (input) {
                    if (typeof input !== 'string' || !input) {
                        return false;
                    }
                    else {
                        return /^\S+@\S+$/.test(input);
                    }
                };
                /**
                 * Check if email exists in current user list.
                 *
                 * @param userlist {Array<{}>} List of users, should have email
                 *     address related to user.
                 * @param input {{}} Input user.
                 * @returns {boolean} True if email_id exists.
                 */
                addressBook.emailExists = function (userlist, input) {
                    if (!userlist || !userlist.length) {
                        // User list is empty.
                        return false;
                    }
                    else {
                        var rs = false;
                        for (var i = 0; i < userlist.length && !rs; i++) {
                            // Also check input type here.
                            if ('email' in userlist[i]) {
                                if (userlist[i].email.toLowerCase() === input.email.toLowerCase() &&
                                    userlist[i]._id !== input._id) {
                                    rs = true;
                                }
                            }
                        }
                        return rs;
                    }
                };
            })(addressBook = mgmts.addressBook || (mgmts.addressBook = {}));
        })(mgmts = r6.mgmts || (r6.mgmts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.mgmts.addressBook;
//# sourceMappingURL=user-verification.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/address-book/app/js/logic/user-verification.js